import styled from "styled-components";
import { FolderOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cases from "../../pages/cases";

const Layout = () => {
  const [showContent, setShowContent] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <Sidebar>
        <FolderIcon onClick={() => setShowContent(!showContent)}>
          <FolderOutlined />
        </FolderIcon>
      </Sidebar>
    </>
  );
};

export default Layout;

const Sidebar = styled.div`
  width: 2.5%;
  height: calc(100vh - 6vh);
  background-color: #161357;
  color: white;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  position: fixed;
  top: 6vh;
  left: 0;
  z-index: 999;
`;

const FolderIcon = styled.div`
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s;
  font-size: 24px;
  position: relative;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

const ContentContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: rgb(7, 38, 89);
  border-radius: 4px;
  padding: 0.5rem;
  min-width: 150px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
`;

const MenuItem = styled.div`
  padding: 0.75rem;
  cursor: pointer;
  border-radius: 4px;
  text-align: left;
  font-size: 0.9rem;
  transition: background-color 0.2s;
  white-space: nowrap;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;